module.exports = __webpack_public_path__ + "img/img_title@3x.75f8c51c.png";